import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { NotificationsService, SimpleNotificationsModule } from 'angular2-notifications';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { ServiceWorkerModule } from '@angular/service-worker';
import { SModule } from 'src/app/SayTS/s.module';
import { CustomTranslateLoader, MissingTranlationConfig } from 'src/app/SayTS/custom-translation';
import { registerLocaleData } from '@angular/common';
import localeCs from '@angular/common/locales/cs';
import localeDe from '@angular/common/locales/de';
import { AuthInterceptor } from 'src/app/SayTS/auth.interceptor';
import { AccessGuard } from 'src/app/SayTS/access-guard';
import { Fce } from 'src/app/SayTS/fce';
import { ErrorService } from 'src/app/SayTS/error.service';
import { SharedService } from 'src/app/_shared/shared.service';

// REP Components - User
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './auth/register/register.component';
import { VerifyEmailComponent } from './auth/verify-email/verify-email.component';
import { RepDashboardComponent } from './dashboard/dashboard.component';
import { ReservationListComponent } from './reservations/reservation-list/reservation-list.component';
import { ReservationFormComponent } from './reservations/reservation-form/reservation-form.component';
import { StationMapComponent } from './_shared/station-map/station-map.component';
import { StationsMapComponent } from './stations-map/stations-map.component';

// REP Components - Admin
import { RepAdminGuard } from './guards/admin.guard';
import { AdminDashboardComponent } from './admin/admin-dashboard/admin-dashboard.component';
import { AdminUsersComponent } from './admin/admin-users/admin-users.component';
import { AdminUserComponent } from './admin/admin-user/admin-user.component';
import { AdminClientComponent } from './admin/admin-client/admin-client.component';
import { AdminClientsComponent } from './admin/admin-clients/admin-clients.component';
import { AdminSettingsComponent } from './admin/admin-settings/admin-settings.component';
import { AdminVehicleTypeComponent } from './admin/admin-vehicle-type/admin-vehicle-type.component';
import { AdminLocationComponent } from './admin/admin-location/admin-location.component';
import { AdminReservationsComponent } from './admin/admin-reservations/admin-reservations.component';
import { AdminLocationsComponent } from './admin/admin-locations/admin-locations.component';
import { RepHeaderComponent } from './header/rep-header.component';

// REP Services
import { RepService } from './services/rep.service';

registerLocaleData(localeCs);
registerLocaleData(localeDe);

@NgModule({
  declarations: [
    AppComponent,
    // User components
    LoginComponent,
    RegisterComponent,
    VerifyEmailComponent,
    RepDashboardComponent,
    ReservationListComponent,
    ReservationFormComponent,
    StationMapComponent,
    StationsMapComponent,
    // Admin components
    AdminDashboardComponent,
    AdminUsersComponent,
    AdminUserComponent,
    AdminClientComponent,
    AdminClientsComponent,
    AdminLocationComponent,
    AdminReservationsComponent,
    AdminLocationsComponent,
    AdminSettingsComponent,
    AdminVehicleTypeComponent,
    // Header
    RepHeaderComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgSelectModule,
    FormsModule,
    NgbModule,
    HttpClientModule,
    SimpleNotificationsModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: 'cs',
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient, NotificationsService]
      },
      ...MissingTranlationConfig
    }),
    NgxSmartModalModule.forRoot(),
    // SwUpdate je injectován v SharedService (relikt po Shift Planner) — musíme
    // ServiceWorkerModule registrovat, jinak DI selže. SW samotný nezapínáme.
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: false }),
    SModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'cs-CZ' },
    SharedService,
    AccessGuard,
    RepAdminGuard,
    Fce,
    RepService,
    { provide: ErrorHandler, useClass: ErrorService }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
